export default __webpack_public_path__ + "static/media/home-travel-agency-bg.760a85a9.jpg";